var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.changeRange($event)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "inline-form", attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: "Customer, Merch or Addons"
                    },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  }),
                  _vm._v(" "),
                  _c("SearchRangePicker", {
                    on: { reloadData: _vm.changeRange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "inline-form filters",
                  attrs: { cols: "12", md: "12" }
                },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.codes,
                      "menu-props": { maxHeight: "400" },
                      label: "Package",
                      multiple: "",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.filters.selectedCodes,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "selectedCodes", $$v)
                      },
                      expression: "filters.selectedCodes"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _vm.statusOpts,
                      "menu-props": { maxHeight: "400" },
                      "item-text": "text",
                      "item-value": "id",
                      label: "Status",
                      multiple: "",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.filters.status,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "status", $$v)
                      },
                      expression: "filters.status"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _vm.transportOpts,
                      label: "Transport",
                      multiple: ""
                    },
                    model: {
                      value: _vm.filters.transport,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "transport", $$v)
                      },
                      expression: "filters.transport"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _vm.paymentMethodOpts,
                      label: "Payment",
                      multiple: ""
                    },
                    model: {
                      value: _vm.filters.paymentMethod,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "paymentMethod", $$v)
                      },
                      expression: "filters.paymentMethod"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _vm.agentsNames,
                      label: "Agent",
                      multiple: ""
                    },
                    model: {
                      value: _vm.filters.agent,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "agent", $$v)
                      },
                      expression: "filters.agent"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredResults,
          "items-per-page": 30,
          "item-key": "id",
          search: _vm.name,
          "sort-by": "startTime"
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                item.incomplete || item.future
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "success white--text ma-2",
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.reschedule(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-update")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !item.incomplete && !item.future && item.status != 4
                  ? _c("StatusChip", { attrs: { status: item.status } })
                  : _vm._e(),
                _vm._v(" "),
                item.status == 4
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          small: "",
                          color: "blue lighten-1",
                          "text-color": "#FFFFFF",
                          href: "/getCertificate/" + item.customer_id
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-certificate-outline")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.startTime",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      new Date(item.startTime).toLocaleString("en-AU", {
                        timeZone: "UTC",
                        weekday: "short",
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                      })
                    )
                  )
                ])
              ]
            }
          },
          {
            key: "item.billItems",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("p", { staticClass: "extras" }, [_vm._v(_vm._s(item.names))])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }